import { gql } from "@apollo/client"

export const REPORT_USER_LIST = gql`
  query ReportUserList($ReportUserListInput: ReportUserListInput!) {
    ReportUserList(input: $ReportUserListInput) {
      status {
        success
        name
        detail
        code
      }
      Persons {
        id
        name
        firstSurname
        lastSurname
        email
        code
        playedTournaments
        emailValid
        documentNumber
        documentNumberType
        Address {
          countryId
          regionId
          locationId
        }
        Tournaments {
          id
          tournamentId
          raceId
          points
          Tournament {
            id
            name
            gameId
            storeId
          }
        }
      }
    }
  }
`

export const REPORT_STORE_TOURNAMENTS = gql`
  query ReportStoreTournaments($ReportStoreTournamentsInput: ReportStoreTournamentsInput!) {
    ReportStoreTournaments(input: $ReportStoreTournamentsInput) {
      status {
        success
        name
        detail
        code
      }
      Tournaments {
        id
        name
        storeId
        startDate
        urlView
        gameId
        typeId
        statusId
        formatId
        TournamentPlayers(paginate: 999) {
          id
          personId
          raceId
          points
          Person {
            id
            name
            firstSurname
            lastSurname
            email
            code
            emailValid
          }
        }
      }
    }
  }
`
